/**
 * Format a number with shorthand suffix: B, M, K.
 * e.g. 100_000_000 → "100M", 1_500_000 → "1.5M", 25_000 → "25K", 999 → "999"
 * Trailing decimal zeroes are stripped automatically.
 */
export const formatCompact = (n: number): string => {
  if (n >= 1_000_000_000) {
    const v = n / 1_000_000_000;
    return (v % 1 === 0 ? v.toFixed(0) : parseFloat(v.toFixed(2)).toString()) + "B";
  }
  if (n >= 1_000_000) {
    const v = n / 1_000_000;
    return (v % 1 === 0 ? v.toFixed(0) : parseFloat(v.toFixed(2)).toString()) + "M";
  }
  if (n >= 1_000) {
    const v = n / 1_000;
    return (v % 1 === 0 ? v.toFixed(0) : parseFloat(v.toFixed(2)).toString()) + "K";
  }
  return n.toLocaleString();
};

/**
 * Format a money value with a leading $ and shorthand suffix.
 * e.g. 1_500_000 → "$1.5M"
 */
export const formatMoney = (n: number): string => `$${formatCompact(n)}`;
